import { Model as BaseModel } from "vue-api-query";
export default class VueApiQueryList {
    constructor(apiSearch = null, apiItem = null) {
        this.apiSearch = apiSearch;
        this.apiItem = apiItem ?? this.apiSearch;
    }

    async list(
        {
            id = null,
            page = 1,
            perPage = 50,
            search = "",
            appliedFilters = [],
            params = null,
            includes = [],
            sort_by = null,
            context = null,
        },
        extra
    ) {
        let apiSearch =
            typeof this.apiSearch === "function" &&
            !(this.apiSearch instanceof BaseModel)
                ? this.apiSearch(id, context, extra)
                : this.apiSearch;

        if (search && search.length) {
            apiSearch = apiSearch.where("search", search);
        }

        if (appliedFilters) {
            appliedFilters.forEach(filter => {
                if (Array.isArray(filter.selected)) {
                    apiSearch = apiSearch.whereIn(filter.name, filter.selected);
                } else {
                    apiSearch = apiSearch.where(filter.name, filter.selected);
                }
            });
        }

        if (params){
            apiSearch = apiSearch.params(params);
        }

        if (includes && includes.length) {
            apiSearch = apiSearch.include(...includes);
        }

        if (sort_by) {
            apiSearch = apiSearch.orderBy(sort_by);
        }

        const items = await apiSearch
            .page(page)
            .limit(perPage)
            .get()
            .then(res => {
                return res;
            });

        return items;
    }

    async find({id, includes}, extra) {
        let apiItem =
            typeof this.apiItem === "function" &&
            !(this.apiItem instanceof BaseModel)
                ? this.apiItem(extra)
                : this.apiItem;

        if (includes && includes.length) {
            apiItem = apiItem.include(...includes);
        }

        return await apiItem.find(id);
    }
}
